import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { getToken } from "../../utils/getToken";

type User = {
  email: string;
  firstName: string;
  lastName: string;
  role: Role;
  passwordChangedAt: any;
  isSuspended: boolean;
  isDeleted: boolean;
  gender: string;
  phoneNumber: string;
  phoneCountryCode: string;
  lastLogin: string;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
  id: string;
  repCode: string;
};

interface Role {
  name: string;
  description: string;
  key: string;
  permission: any[];
  id: string;
}

export const useGetMeQuery = () => {
  const token = getToken();

  return useQuery({
    queryKey: ["useGetMeQuery"],
    queryFn: () =>
      axiosInstance
        .get("/admins/me", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => res.data as { data: User }),
    enabled: !!token,
    staleTime: 0,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    refetchOnReconnect: true,
  });
};
